import config from "config";
import { TBinBytes } from "utils/jumbomailSettings.js";

export const purchaseCodesList = [
  // {
  //   num: 3,
  //   price: {
  //     ILS: 45,
  //     USD: 12,
  //     EUR: 11,
  //   },
  //   isPopular: false,
  // },
  {
    num: 5,
    price: {
      ILS: 60,
      USD: 16,
      EUR: 15,
    },
    isPopular: false,
  },
  {
    num: 10,
    price: {
      ILS: 99,
      USD: 26,
      EUR: 25,
    },
    isPopular: true,
  },
  {
    num: 20,
    price: {
      ILS: 149,
      USD: 39,
      EUR: 37,
    },
    isPopular: false,
  },
];

export const purchasePlanDetails = {
  pro: {
    TransactionPackageName: "pro",
    TransactionPurchaseType: "subscription",
  },
  business: {
    TransactionPackageName: "business",
    TransactionPurchaseType: "subscription",
  },
  premium: {
    TransactionPackageName: "premium",
    TransactionPurchaseType: "subscription",
  },
  "pay-as-you-go": {
    TransactionPackageName: "pay-as-you-go",
    TransactionPurchaseType: "pay-as-you-go",
  },
  "pay-as-you-go": {
    TransactionPackageName: "codes",
    TransactionPurchaseType: "codes",
  },
  "sub-users": {
    TransactionPackageName: "sub-users",
    TransactionPurchaseType: "addons",
  },
  "extra-storage": {
    TransactionPackageName: "extra-storage",
    TransactionPurchaseType: "addons",
  },
};

//return if the inputs in the payment form are valid and set invalid list
export const validatePaymentFields = ({
  firstName,
  lastName,
  email,
  phone,
  invoiceName,
  companyId,
  setInvalidList,
}) => {
  let isValid = true;
  let invalidFields = [];
  const phoneRegex = /^(?=.{9,18}$)[0-9#()+-]*$/;
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //First name validation
  if (firstName) {
    //check if first name is more than 50 chars
    if (firstName.length > 50) {
      isValid = false;
      invalidFields.push("purchase-first-name-label");
    }
  } else {
    isValid = false;
    invalidFields.push("purchase-first-name-label");
  }

  //Last name validation
  if (lastName) {
    //check if last name is more than 50 chars
    if (lastName.length > 50) {
      isValid = false;
      invalidFields.push("purchase-last-name-label");
    }
  } else {
    isValid = false;
    invalidFields.push("purchase-last-name-label");
  }

  // if (country === null) {
  //   isValid = false;
  //   invalidFields.push("purchase-country-label");
  // }

  if (email) {
    if (!emailRegex.test(email)) {
      isValid = false;
      invalidFields.push("purchase-email-label");
    }
  } else {
    isValid = false;
    invalidFields.push("purchase-email-label");
  }

  if (phone) {
    if (!phoneRegex.test(phone)) {
      isValid = false;
      invalidFields.push("purchase-phone-label");
    }
  } else {
    isValid = false;
    invalidFields.push("purchase-phone-label");
  }

  //inoice name validation
  if (invoiceName) {
    //check if invoice name is more than 100 chars
    if (invoiceName.length > 100) {
      isValid = false;
      invalidFields.push("purchase-invoice-name-label");
    }
  } else {
    isValid = false;
    invalidFields.push("purchase-invoice-name-label");
  }

  //company id validation
  if (companyId) {
    //check if company id is more than 12 chars
    if (companyId.length > 12) {
      isValid = false;
      invalidFields.push("purchase-company-id-label");
    } else {
      //check if company id is only numbers or letters
      const regexCompanyId = /^[a-zA-Z0-9]+$/;
      if (!regexCompanyId.test(companyId)) {
        isValid = false;
        invalidFields.push("purchase-company-id-label");
      }
    }
  }

  setInvalidList(invalidFields);
  //return false;
  return isValid;
};

export const redirectToOtherUrl = (pageToRedirect, lang) => {
  let url = `${config.baseurl}/${lang}/${pageToRedirect}`;
  //if url include 3000, relpace https with http
  if (window.location.href.includes("3000")) {
    url = url.replace("https", "http");
  }
  window.location.href = url;
};

export const checkIfIsDowngrade = ({ purchaseType, billingDetails }) => {
  let isDowngrade = false;
  const purchaseNum =
    purchaseType === "pro"
      ? 1
      : purchaseType === "business"
      ? 2
      : purchaseType === "premium"
      ? 3
      : 0;
  if (billingDetails && billingDetails.type && purchaseNum > 0) {
    //check if is downgrade
    const currentPurchaseNum =
      billingDetails.type === "pro"
        ? 1
        : billingDetails.type === "business"
        ? 2
        : 3;
    if (currentPurchaseNum > purchaseNum) {
      isDowngrade = true;
    }
  }

  return isDowngrade;
};

export const checkIfDowngradeByPlans = ({ currentPlan, purchasePlan }) => {
  let isDowngrade = false;
  const currentPurchaseNum =
    currentPlan === "pro" ? 1 : currentPlan === "business" ? 2 : 3;
  const purchaseNum =
    purchasePlan === "pro" ? 1 : purchasePlan === "business" ? 2 : 3;
  if (currentPurchaseNum > purchaseNum) {
    isDowngrade = true;
  }
  return isDowngrade;
};

export const checkValidateStorageDowngradePlans = ({
  extraStorage,
  actualStorage,
  packageStorage,
}) => {
  //limit storage after downgrade
  const extraStorageInBytes = extraStorage * TBinBytes;
  const PackageStorageInBytes = packageStorage * TBinBytes;

  let limitStorageAfterDowngrade = extraStorageInBytes + PackageStorageInBytes;
  return actualStorage <= limitStorageAfterDowngrade;
};

export const externalValidateDowngradeSubscriptions = ({
  currentUserDetails,
  purchaseDetails,
}) => {
  //Current details:
  const billingMethod = currentUserDetails?.billingMethod;
  const billingPeriod = currentUserDetails?.billingPeriod;
  const userPlan = currentUserDetails?.userPlan;
  const userExtraStorage = currentUserDetails?.userExtraStorage;
  const userActualStorage = currentUserDetails?.userActualStorage;
  const numOfForms = currentUserDetails?.numOfForms;
  //Purchase details:
  const purchasePaymentMethod =
    purchaseDetails?.paymentMethod === "newcreditcard"
      ? "creditcard"
      : purchaseDetails?.paymentMethod;
  const purchasePeriod = purchaseDetails?.period;
  const purchasePlan = purchaseDetails?.plan;
  const isDowngrade = userPlan
    ? checkIfDowngradeByPlans({
        currentPlan: userPlan,
        purchasePlan: purchasePlan,
      })
    : false;

  //Result:
  let result = {
    allowPurchase: true,
    toastMessage: "",
    modalName: "",
  };

  // ! logic moved outside to the checkIfChangePayMethodAllowed function
  // if (billingMethod) {
  //   if (billingMethod?.toLowerCase() !== 'wire' && billingMethod !== purchasePaymentMethod) {
  //     result = {
  //       allowPurchase: false,
  //       toastMessage: "cannot-change-payment-method",
  //       modalName: "",
  //     };
  //     return result;
  //   }
  // }

  if (billingPeriod) {
    if (billingPeriod === 12 && purchasePeriod === "monthly") {
      result = {
        allowPurchase: false,
        toastMessage: "cannot-change-yearly-to-monthly",
        modalName: "",
      };
      return result;
    }
  }

  const isTheSamePeriod =
    (billingPeriod === 12 && purchasePeriod === "yearly") ||
    (billingPeriod === 1 && purchasePeriod === "monthly");

  if (
    userPlan === purchasePlan &&
    // isTheSamePeriod &&
    !currentUserDetails?.IsFreeProFromCoupon &&
    // Allow purchase same package if subscription status is INACTIVE,
    // which means teh subscription was canceled on PayPal side.
    !currentUserDetails.isSubscriptionInactive &&
    billingMethod?.toLowerCase() !== "wire" &&
    (currentUserDetails?.token_id || currentUserDetails?.provider_id)
  ) {
    if (!currentUserDetails.autoRenew) {
      result = {
        allowPurchase: false,
        toastMessage: "",
        modalName: "auto-renewal",
      };
    } else {
      result = {
        allowPurchase: false,
        toastMessage: "",
        modalName: "same-package",
      };
      return result;
    }
  }

  if (isDowngrade) {
    //Check if exists sub users
    // if (userSubUsersLicneses > 0) {
    //   result = {
    //     allowPurchase: false,
    //     toastMessage: "",
    //     modalName: "sub-users",
    //   };
    //   return result;
    // }

    const planStorage = purchasePlan === "pro" ? 0.5 : 1;
    //check used storage after downgrade
    const allowDowngrade = checkValidateStorageDowngradePlans({
      extraStorage: userExtraStorage,
      actualStorage: userActualStorage,
      packageStorage: planStorage,
    });

    if (!allowDowngrade) {
      result = {
        allowPurchase: false,
        toastMessage: "",
        modalName: "min-storage",
      };
      return result;
    }

    //if current plan is premium, need to check if num of forms is more than 1, if yes, need to show modal
    if (userPlan === "premium" && numOfForms > 1) {
      result = {
        allowPurchase: false,
        toastMessage: "",
        modalName: "jumboforms-count",
      };
      return result;
    }
  }

  return result;
};

export const extrenalValidateDowngradeAddons = ({
  billingMethod,
  purchaseMethod: purchasePaymentMethod,
  userPlan,
  purchaseAddon,
}) => {
  //Result:
  let result = {
    allowPurchase: true,
    toastMessage: "",
    modalName: "",
  };

  const purchaseMethod =
    purchasePaymentMethod === "newcreditcard"
      ? "creditcard"
      : purchasePaymentMethod;

  if (billingMethod) {
    if (
      billingMethod?.toLowerCase() !== "wire" &&
      billingMethod !== purchaseMethod
    ) {
      result = {
        allowPurchase: false,
        toastMessage: "cannot-change-payment-method",
        modalName: "",
      };
      return result;
    }
  }

  if (!userPlan) {
    result = {
      allowPurchase: false,
      toastMessage: "",
      modalName:
        purchaseAddon === "sub-users"
          ? "NotBusinessSubUsersModal"
          : "NotSubscriberExtraStorage",
    };
    return result;
  }

  if (purchaseAddon === "sub-users") {
    if (userPlan === "pro") {
      result = {
        allowPurchase: false,
        toastMessage: "",
        modalName: "NotBusinessSubUsersModal",
      };
      return result;
    }
  }

  return result;
};
